import { render, staticRenderFns } from "./RobotList.vue?vue&type=template&id=1b847248&scoped=true"
import script from "./RobotList.vue?vue&type=script&lang=js"
export * from "./RobotList.vue?vue&type=script&lang=js"
import style0 from "./RobotList.vue?vue&type=style&index=0&id=1b847248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b847248",
  null
  
)

export default component.exports